module.exports = __webpack_public_path__ + "static/img/AB4338763.2ec521ad.jpg";